module.exports = __webpack_public_path__ + "img/id-call-me-emperor.b2d6f91.png";